import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LanguageComponent from "../../Components/LangTranslation/LanguageComponent";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import CardLayout from "../../Components/Card/CardLayout";
import ShortcutButton from "../../Components/ShortcutButtons/ShortcutButton";
import ButtonList from "../../Components/ShortcutButtons/btnDetailList";
import ProgressMap from "../../Components/ProgressMap/ProgressMap";
import { exclaimCompanyForm } from "../../DataApi/setting/companyForm";
import { exclamationSubscription } from "../../DataApi/setting/subscription";
import { onbProgress } from "../../DataApi/setting/onboardingProgress";
import { connectSocialMedia } from "../../DataApi/settings/connectSocialMedia";
import { posLink } from "../../DataApi/pointOfSaleLink";

function Setting() {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();
  let menuItemLink = null;

  const [exclaimCompanyData, setExclaimCompanyData] = useState({
    msg: "",
    show: false,
  });
  const [exclaimSubscription, setExclaimSubscription] = useState({
    msgSub: "",
    showSub: false,
  });
  const [onbProgressInfo, setonbProgress] = useState({
    user_cr_info: false,
    product_state: false,
  });
  const state = {
    openCompanyModal: true,
  };

  const handleClickCouponOrPromotion = async (menuItem) => {
    try {
      let response = await posLink(menuItem);
      response = JSON.parse(response);
      if (response?.result) {
        // menuItemLink = "http://127.0.0.1:8069" + response?.result?.url;
        menuItemLink = origin + response?.result?.url;
        // console.log("response of link api and menu item", response, menuItemLink);

        // Open the link in a new tab
        window.open(menuItemLink, "_blank").focus();
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleExclaimCompanyForm = (exclaimCompany) => {
    setExclaimCompanyData({ ...exclaimCompany });
  };
  const handleExclaimSubscription = (exclaimSub) => {
    setExclaimSubscription({ ...exclaimSub });
  };
  const handleOnbProgress = (info) => {
    setonbProgress({ ...info });
  };
  const getSocialMediaConnection = async () => {
    var socialMediaResult = await connectSocialMedia();
    socialMediaResult = JSON.parse(socialMediaResult);
    var newPage = window.open(socialMediaResult.result.url, "_blank");
    if (newPage) {
      newPage.focus();
    }
  };
  const handleButtonClick = (dataId) => {
    let host = window.location.host;
    // console.log("host", host);
    switch (dataId) {
      case 101:
        navigate("/homepage/subscription");
        break;
      case 102:
        navigate("/homepage/company", { state });
        break;
      case 103:
        getSocialMediaConnection();
        break;
      case 104:
        navigate("/homepage/orders");
        break;
      case 105:
        navigate("/homepage/contacts");
        break;
      case 106:
        navigate("/homepage/crm");
        break;
      case 107:
        navigate("/homepage/products");
        break;
      case 108:
        // console.log("first", `${host}/?enable_editor=1`);
        var website = window.open(`https://${host}?enable_editor=1`, "_blank");
        if (website) {
          website.focus();
        }
        break;
      case 109:
        // console.log("coupon");
        handleClickCouponOrPromotion("sale_coupon.menu_coupon_type_config");
        break;
      case 110:
        // console.log("promotion");
        handleClickCouponOrPromotion("sale_coupon.menu_promotion_type_config");
        break;
      case 111:
        // console.log("Legacy System");
        var legacy = window.open(`https://${host}/web`, "_blank");
        if (legacy) {
          legacy.focus();
        }
        break;
      default:
      // Default case
    }
  };
  const getUserOnboardProgress = async () => {
    try {
      const resultOnb = await onbProgress("res.users");
      if (resultOnb.result) {
        handleOnbProgress(resultOnb.result);
      } else {
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const getExclaimSubscription = async () => {
    try {
      const resultSub = await exclamationSubscription("res.users");
      if (resultSub.result) {
        handleExclaimSubscription(resultSub.result);
      } else {
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const getExclaimCompanyForm = async () => {
    try {
      const result = await exclaimCompanyForm("res.users");
      if (result.result) {
        handleExclaimCompanyForm(result.result);
      } else {
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    getExclaimCompanyForm();
    getExclaimSubscription();
    getUserOnboardProgress();
  }, []);
  return (
    <>
      <div className="container-fluid mt-5">
        <div className="row px-2">
          <div className=" col-lg-4">
            <CardLayout>
              <div className="row">
                <div className="col">
                  <h5
                    className="card-title  mb-2"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "18px",
                      color: "#4E5D78",
                      fontWeight: 600,
                    }}
                  >
                    {t["Language"]}
                  </h5>

                  <LanguageComponent />
                </div>
              </div>
            </CardLayout>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-5">
        <div className="row px-2">
          <div className=" col-lg-12">
            <CardLayout>
              <div className="row">
                <div className="col">
                  <h5
                    className="card-title  mb-2"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "18px",
                      color: "#4E5D78",
                      fontWeight: 600,
                    }}
                  >
                    {t["Progress Map"]}
                  </h5>
                </div>
              </div>
              <ProgressMap
                crInfo={onbProgressInfo.user_cr_info}
                productInfo={onbProgressInfo.product_state}
              />
            </CardLayout>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-5">
        <div className="row px-2">
          <div className=" col-lg-12">
            <CardLayout>
              <div className="row">
                <div className="col">
                  <h5
                    className="card-title  mb-2"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "18px",
                      color: "#4E5D78",
                      fontWeight: 600,
                    }}
                  >
                    {t["Shortcut Keys"]}
                  </h5>
                </div>
                <div className="row mx-1 py-3 my-3 o_dynamic_dashboard">
                  {ButtonList().map((button) => (
                    <ShortcutButton
                      key={button.dataId}
                      dataId={button.dataId}
                      name={button.name}
                      show={exclaimCompanyData.show}
                      msg={exclaimCompanyData.msg}
                      showSub={exclaimSubscription.show}
                      msgSub={exclaimSubscription.msg}
                      onClick={() => handleButtonClick(button.dataId)}
                    />
                  ))}
                </div>
              </div>
            </CardLayout>
          </div>
        </div>
      </div>
    </>
  );
}

export default Setting;
